import { Language, type SupportedLanguage } from './types';

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
	Language.En,
	Language.Es,
	Language.It
];

export const DEFAULT_LANGUAGE: SupportedLanguage = Language.En;

export const LanguageMeta = {
	en: {
		label: 'English',
		flag: '🇺🇸'
	},
	es: {
		label: 'Español',
		flag: '🇪🇸'
	},
	it: {
		label: 'Italiano',
		flag: '🇮🇹'
	}
} as const;
